<template>
  <div class="success-page">
    <img
      class="logo-img"
      width="240"
      height="70"
      src="@/assets/img/logo_landing.png"
      srcset="@/assets/img/logo_landing@2x.png 2x, @/assets/img/logo_landing@3x.png 3x"
      alt="听语logo">
    <img
      class="success-img"
      width="160"
      height="160"
      src="@/assets/img/icon_landing_success.png"
      srcset="@/assets/img/icon_landing_success@2x.png 2x, @/assets/img/icon_landing_success@3x.png 3x"
      alt="领取成功">
    <div class="success-title">领取成功</div>
    <div class="success-text">VIP会员有效期31天，赶快下载体验吧！</div>
    <div
      class="download-btn"
      @click="download"
      @touchstart="submitPressed = true"
      @touchend="submitPressed = false"
      >立即下载</div>
      <!-- :class="submitPressed ? 'pressed' : ''" -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      submitPressed: false
    }
  },
  methods: {
    download () {
      //
      this.$router.push({ path: '/download', query: { type: 'speech' } })
    }
  }
}
</script>

<style lang="scss" scoped>
  .success-page {
    position: relative;
    height: 100vh;
    padding-top: 254px;
    background-image: linear-gradient(177deg, rgba(138,208,255,0.88), rgba(52,152,219,0.88), rgba(12,128,205,0.88));
    & .logo-img {
      position: absolute;
      top: 33px;
      left: 40px;
      width: 240px;
      height: 70px;
    }
    & .success-img {
      margin-bottom: 60px;
    }
    & .success-title {
      margin-bottom: 33px;
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    & .success-text {
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #fff;
      margin-bottom: 80px;
    }
    & .download-btn {
      width: 654px;
      height: 144px;
      margin: 0 auto;
      line-height: 144px;
      font-size: 34px;
      font-family: PingFang SC;
      font-weight: 500;
      color:#4B3603;
      background-image: url(~@/assets/img/btn_landing.png);
      background-repeat: no-repeat;
      background-size: 100% auto;
      &:active {
        background-image: url(~@/assets/img/btn_landing_pressed.png);
      }
      &.pressed {
        background-image: url(~@/assets/img/btn_landing_pressed.png);
      }
    }
  }
  @media only screen and (-webkit-min-device-pixel-ratio:2) {
    .submit-btn {
      background-image: url(~@/assets/img/btn_landing@2x.png);
      &.pressed {
        background-image: url(~@/assets/img/btn_landing_pressed@3x.png);
      }
    }
  }
  @media only screen and (-webkit-min-device-pixel-ratio:3) {
    .submit-btn {
      background-image: url(~@/assets/img/btn_landing@3x.png);
      &.pressed {
        background-image: url(~@/assets/img/btn_landing_pressed@3x.png);
      }
    }
  }
</style>
